/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pll_Toast_Cancel_PxkInputs */

const vi_pll_toast_cancel_pxk = /** @type {(inputs: Pll_Toast_Cancel_PxkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đã hủy phiếu`)
};

/**

* @param {Pll_Toast_Cancel_PxkInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const pll_toast_cancel_pxk = /** @type {((inputs?: Pll_Toast_Cancel_PxkInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pll_Toast_Cancel_PxkInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_pll_toast_cancel_pxk(inputs)
});